import React from 'react';
import Modal from '@synergycms_core/components/generic/Modal';
import styleFile from '../../../views/customerForm/CustomerForm.js';
import { withThemeJSS } from '@synergycms_core/components/providers/themeProvider';
import RichText from '@synergycms_core/components/generic/RichText';
import { compose } from "ramda";

const ConditionsModal = props => {
  const { classes } = props.theme.styles;
  const firstUpper = props.ucFirst ? props.ucFirst : false
  const isStarTraveler = props.isStarTraveler ? props.isStarTraveler : false
  return (
    <Modal
      innerStyle={['modalStyle']}
      contentStyle={classes.availModalcontent}
      closeButtonStyle={classes.closeButton}
      modalStyle={classes.hotelModalStyle}
      popover={
        <div className={classes.modalTabsList}>
          <div className={classes.headerModal}>
            <RichText
              innerStyle={classes.modalTitle}
              text={props.modalTitle}
              translate={true}
              ucFirst={true}
            />
          </div>
          <div className={classes.titleListBlock}>
            <RichText
              innerStyle={['roboto13Black', isStarTraveler ? classes.termsST : '']}
              dangerouslySetInnerHTML={props.modalText}
              translate={true}
            />
          </div>
        </div>
      }
      typeModal={'roomDetailTooltip'}>
      <div className={classes.policiesTextToggle}>
        <RichText
          translate={true}
          innerStyle={['gold', classes.politicsText, isStarTraveler ? classes.termsST : '']}
          text={props.modalTitle}
          ucFirst={firstUpper}
        />
      </div>
    </Modal>
  );
};

export default compose(withThemeJSS({ styleFile, link: true, displayName: 'ConditionsModal' }))(ConditionsModal);
